import { Link } from "react-router-dom";
import { FaTimes } from "react-icons/fa";

const NotFound = () => {
    return (
        <div className="pb-24">
            <div className="grid place-items-center mt-[200px] text-center">
                <div className="w-[100px] h-[100px] mb-5">
                    <FaTimes className="w-full h-full" />
                </div>
                <div>
                    <p>
                        Nothing here
                        <Link to={"/"} className="block underline font-medium">
                        Go back to homepage
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
